<template>
  <v-form ref="form">
    <div class="d-flex flex-row">
      <!-- Avatar -->
      <div v-if="selectedAvatar" class="col-lg-3">
        <img
          :src="selectedAvatar"
          style="width: 100%; border-radius: 5%"
          alt="avatar-tmg"
        />

        <!-- Générer: actif ou non actif en fonction du dernier token généré -->
        <!-- TODO: SI la période entre la date de la déconnexion et la date de connexion < 2 592 000 s (1 mois) ALORS "actif" SINON "inactif"  -->
        <div
          class="
            d-flex
            flex-column
            justify-content-center
            align-items-center
            pt-2
            pb-5
          "
        >
          <div v-if="user.lastConnection">
            Dernière connexion: {{ user.lastConnection | moment }}
          </div>

          <div class="mt-1">
            <v-chip
              color="red"
              text-color="white"
              v-if="mode === 'edit' && !isActive"
            >
              Inactif
            </v-chip>

            <v-chip
              color="green"
              text-color="white"
              v-if="mode === 'edit' && isActive"
            >
              Actif
            </v-chip>

            <v-chip
              class="mx-2"
              color="pink"
              text-color="white"
              v-if="user.type == '0'"
            >
              Interne
            </v-chip>
            <v-chip
              class="mx-2"
              color="blue"
              text-color="white"
              v-if="user.type == '1'"
            >
              SSO
            </v-chip>
          </div>

          <a
            ref="btn-send-password"
            class="btn btn-primary mt-2"
            @click="sendPassword"
          >
            Envoyer mot de passe de connexion
          </a>
        </div>
      </div>

      <div class="col-lg-9">
        <!-- Nom -->
        <v-text-field
          v-model="user.lastname"
          :rules="nameErrors"
          :counter="150"
          label="Nom de l'utilisateur *"
          required
        ></v-text-field>

        <!-- Prénom -->
        <v-text-field
          v-model="user.firstname"
          :rules="nameErrors"
          :counter="150"
          label="Prénom de l'utilisateur *"
          required
        ></v-text-field>

        <!-- Email -->
        <v-text-field
          v-model="user.email"
          :rules="emailErrors"
          label="E-mail *"
          required
        ></v-text-field>
        <v-switch
          v-if="user.type == '1'"
          v-model="user.ssoUpdate"
          label="Activer la mise à jour via SSO (rôles, droit, et infos)"
        >
        </v-switch>
      </div>
    </div>

    <!-- Commentaire -->
    <v-textarea v-model="user.comment" label="Commentaire utilisateur" />

   <!-- Stats -->
    <v-card flat v-if="mode != 'add'">
      <v-row dense align="center" justify="center" class="pa-10">
        <v-col
          v-for="(item, i) in userStats"
          :key="i"
          class="my-3 col-md-3 col-sm-4 col-xs-6"
        >
          <v-card :color="item.color">
            <div class="d-flex flex-no-wrap justify-space-between py-4 px-5">
              <div>
                <h5 class="title-truncate">{{ item.description }}</h5>
                <p>{{ item.value }}</p>
              </div>

              <v-avatar tile>
                <v-icon>
                  {{ item.icon }}
                </v-icon>
              </v-avatar>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-card>

    <!-- Rôle -->
    <v-select
      v-if="mode === 'edit'"
      v-model="user.roles[0]"
      :items="['ROLE_USER', 'ROLE_FREEMIUM', 'ROLE_SUPER_USER', 'ROLE_ADMIN']"
      label="Rôle de l'utilisateur *"
      :rules="rules.select"
      required
    ></v-select>

    <v-select
      v-if="mode === 'add'"
      v-model="user.roles"
      :items="['ROLE_USER', 'ROLE_FREEMIUM', 'ROLE_SUPER_USER', 'ROLE_ADMIN']"
      label="Rôle de l'utilisateur *"
      required
    ></v-select>

    <!-- Mot de passe -->
    <v-text-field
      v-if="mode === 'add'"
      v-model="user.password"
      :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
      :rules="[rules.required, rules.min]"
      :type="show ? 'text' : 'password'"
      name="input-10-1"
      label="Mot de passe"
      hint="minimum 8 caractères"
      counter
      @click:append="show = !show"
      required
    ></v-text-field>

    <v-btn class="float-right" color="primary" @click="submit"> Valider </v-btn>
  </v-form>
</template>
<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import Api from "@/core/services/api.service";
import moment from "moment";
import Swal from "sweetalert2";
//import VueMoment from 'vue-moment';

export default {
  name: "formUserBosco",
  data() {
    return {
      userStats: [],
      loading: false,
      valid: false,
      nameErrors: [
        (v) => !!v || "Mention est obligatoire.",
        //(v) => v.length >= 2 || "Le nom doit être supérieur à 2 caractères",
      ],
      emailErrors: [
        (v) =>
          !v ||
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          "L'adresse e-mail n'est pas valide",
      ],
      show: false,
      password: "Password",
      rules: {
        select: (value) => !!value || "Required.",
        min: (v) => v.length >= 8 || "Min 8 characters",
        required: (value) => !!value || "Required.",
        //emailMatch: () => ('The email and password you entered don\'t match')
      },
      avatars: [
        "/media/svg/avatars/v1.jpg",
        "/media/svg/avatars/v2.jpg",
        "/media/svg/avatars/v3.jpg",
        "/media/svg/avatars/v4.jpg",
        "/media/svg/avatars/v5.jpg",
        "/media/svg/avatars/v6.jpg",
        "/media/svg/avatars/v7.jpg",
      ],
      selectedAvatar: null,
    };
  },

  model: {
    prop: "user",
    event: "input",
  },

  props: {
    user: Object,
    mode: String,
  },
  computed: {
    apiUrl() {
      return process.env.VUE_APP_API;
    },
    isActive() {
      var duration = moment.duration(
        moment().diff(moment.parseZone(this.user.lastConnection))
      );
      var days = duration.asDays();
      return days < 31;
    },
  },

  filters: {
    moment: function (date) {
      return moment.parseZone(date).format("DD/MM/YYYY");
    },
  },

  methods: {
    submit(e) {
      e.preventDefault();
      if (this.$refs.form.validate()) {
        this.$emit("submit");
      }
    },
    randomItem(items) {
      return items[Math.floor(Math.random() * items.length)];
    },
    sendPassword() {
      const sendPasswordButton = this.$refs["btn-send-password"];
      sendPasswordButton.classList.add(
        "spinner",
        "spinner-light",
        "spinner-right"
      );

      Api.patch("users", `${this.user.id}/send-password`, { id: this.user.id })
        .then((response) => {
          if (response.status === 200) {
            Swal.fire({
              title: "",
              text: "Un mail contenant le nouveau mot de passe de l'utilisateur a bien été envoyé.",
              icon: "success",
              confirmButtonClass: "btn btn-secondary",
            });
          }
        })
        .finally(() => {
          sendPasswordButton.classList.remove(
            "spinner",
            "spinner-light",
            "spinner-right"
          );
        });
    },
  },

  created() {
    this.selectedAvatar = this.randomItem(this.avatars);
  },

  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Administration", route: "gestionClients" },
      { title: "Gestion des clients" },
    ]);
    this.userStats.push({description: "Parcour(s) démarré(s)",value:this.user["nbCourseStarted"],icon:"fas fa-tasks",color:""});
    this.userStats.push({description: "Parcour(s) complété(s)",value:this.user["nbCourseStarted"],icon:"fas fa-check-circle",color:""});
    this.userStats.push({description: "Connexion totales",value:this.user["nbConnection"],icon:"fas fa-sign-in-alt",color:""});
  },
};
</script>
<style lang="scss" scoped>
.noUserRight {
  font-style: italic;
  text-align: center;
}
td:first-child {
  padding-top: 0.05px;
  padding-bottom: 0.05px;
  padding-left: 15px;
}
</style>
